export default __webpack_public_path__ + "static/media/paint-brush-1.e54d3394.png";